import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import * as Icons from "react-feather";
import SideBarMenu from "./SideBarMenu";
import SKAlerts, {CreateAlert} from "../shared/common-alerts/SKAlerts";
import { getStorageValues } from "../shared/CommonFunctions";
import { getApiBaseUrl } from "../utils/apiConfig";

const Home = () => {
  const [getFullName, setFullName] = useState(getStorageValues('user'));
  const [getRoleName] = useState(getStorageValues('userRole'));
  const [getUserModules, setUserModules] = useState([]);
  const [getNotifications, setNotifications] = useState([]);
  const [getCompanyInfo, setCompanyInfo] = useState([]);
  const [hoveredNotificationId, setHoveredNotificationId] = useState(null);
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);

  const closeSidebar = useCallback(() => {
    if (window.innerWidth < 991) {
      document.querySelector(".main-wrapper")?.classList.remove("slide-nav");
      document.querySelector(".sidebar-overlay")?.classList.remove("opened");
      document.getElementById("task_window")?.classList.remove("opened");
      document.documentElement.classList.remove("menu-opened");
    }
  }, []);

  useEffect(() => {
    if (!document.querySelector(".sidebar-overlay")) {
      const overlayElement = document.createElement("div");
      overlayElement.className = "sidebar-overlay";
      document.body.appendChild(overlayElement);
    }

    const handleDocumentClick = (event) => {
      const mobileButton = event.target.closest("#mobile_btn");
      if (mobileButton) {
        event.preventDefault();
        event.stopPropagation();
        document.querySelector(".main-wrapper")?.classList.toggle("slide-nav");
        document.querySelector(".sidebar-overlay")?.classList.toggle("opened");
        document.documentElement.classList.toggle("menu-opened");
        document.getElementById("task_window")?.classList.remove("opened");
        return;
      }

      const sidebarOverlay = event.target.closest(".sidebar-overlay");
      if (sidebarOverlay) {
        event.preventDefault();
        event.stopPropagation();
        closeSidebar();
      }
    };

    document.addEventListener("click", handleDocumentClick, true);

    return () => {
      document.removeEventListener("click", handleDocumentClick, true);
    };
  }, [closeSidebar]);

  

  const nest = (array) => {
    const nested = [];
    for (var i = 0; i < array.length; i++) {
      var parent = array[i].ParentModuleId;
      if (!parent) {
        nested.push(array[i]);
      } else {
        for (var j = 0; j < array.length; j++) {
          if (array[j].ModuleId === parent) {
            array[j].children = array[j].children || [];
            array[j].children.push(array[i]);
          }
        }
      }
    }
    return nested;
  };
  async function clearAllNotifications(UserNotificationId) {
    try {
      let notiDetails = {
        UserId: getStorageValues('userId'),
        UserNotificationId: UserNotificationId
      };
      const response = await axios.post(
        getApiBaseUrl() + "/deleteNotifications", notiDetails
      );
      if (response.status === 200) {
        CreateAlert("Notes deleted Successfully!!", "Success", setAlert);
        fetchNotifications();
      } 
    } catch (error) {
      console.log(error);
    }
  }
  const fetchNotifications = async () => {
    try {
      let notiDetails = {
        UserId: getStorageValues('userId'),
      };
      const response = await axios.get(
        getApiBaseUrl() + "/getNotifications", {params: notiDetails}
      );
      if (response.status === 200) {
        setNotifications(response.data.data[0]);
      }
    } catch (error) {
      CreateAlert("Some Problem loading Notifications!!","Error",setAlert);
      console.log(error);
    }
  };
  const fetchCompanyInfo = async () => {
    try {
      let companyDetails = {
        UserId: getStorageValues('userId'),
        CompanyId: process.env.REACT_APP_COMPANY_ID
      };
      const response = await axios.get(
        getApiBaseUrl() + "/getCompanyInfo", {params: companyDetails}
      );
      if (response.status === 200) {
        setCompanyInfo(response.data.data[0][0]);
      }
    } catch (error) {
      CreateAlert("Some Problem loading Company!!","Error",setAlert);
      console.log(error);
    }
  };
  useEffect(() => {
    const fetchUser = async () => {
      // If debug bypass is active, skip token validation
      const debugUserId = process.env.REACT_APP_DEBUG_USER_ID;
      if (debugUserId && getStorageValues('token') === 'debug') {
        // Trust local storage during debug bypass
      } else {
        try {
          const token = getStorageValues('token');
          const response = await axios.get(getApiBaseUrl() + "/home", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status !== 200) {
            navigate("/login");
          }
        } catch (error) {
          navigate("/login");
          console.log(error);
        }
      }
    };
    fetchUser();
    const fetchModules = async () => {
      try {
        const response = await axios.get(
          getApiBaseUrl() + "/usermodules?UserId=" +
          getStorageValues('userId') + "&IsForDropdown=0&RoleId=" +
          Number(getStorageValues('userRoleId')) + "&ApplicationId=" +
          process.env.REACT_APP_APPLICATION_ID
        );
        if (response.status === 200) {
          if(response.data.data.length > 0) {
            setUserModules(nest(response.data.data));
          } else {
            CreateAlert("There are no modules assigned to this user!!","Warning",setAlert);
          }
        }
      } catch (error) {
        CreateAlert("Some Problem loading Modules!!","Error",setAlert);
        navigate("/login");
        console.log(error);
      }
    };
    fetchModules();
    fetchNotifications();
    fetchCompanyInfo();
    setFullName(getStorageValues('user'));
  }, [navigate]);

  const handleLogout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.setItem('skcs_manual_logout', '1');
    window.addEventListener("storage", (e) => {
      if (e.key === "IsLogedIn" && e.newValue === undefined) {
        // Perform actions like redirecting to login page
        window.location.href = "/login"; // Redirect to login page
      }
    });
  };
  const renderNoti = getNotifications.map((obj) => {
      return (
        <li 
          className="notification-message" 
          key={obj.UserNotificationId}
          onMouseEnter={() => setHoveredNotificationId(obj.UserNotificationId)}
          onMouseLeave={() => setHoveredNotificationId(null)}
        >
          <Link to={ obj.ActionURL } title={obj.ViewTitle}>
            <div className="media d-flex">
              <span className="avatar flex-shrink-0">
                <img alt="" src={"/assets/img/profiles/" + obj.CreateByUserImagePath} />
              </span>
              <div className="media-body flex-grow-1">
                <div dangerouslySetInnerHTML={{ __html: obj.NotificationText }} >
                </div>
                <p className="noti-time">
                  <span className="notification-time">
                    {obj.TimeDifference}
                  </span>
                </p>
              </div>
              {hoveredNotificationId === obj.UserNotificationId && (
                <span 
                  className="delete-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    clearAllNotifications(obj.UserNotificationId);
                  }}
                  title="Delete notification"
                  style={{ cursor: 'pointer', marginLeft: '10px' }}
                >
                  <Icons.Trash2 size={16} color="#dc3545" />
                </span>
              )}
            </div>
          </Link>
        </li>
      );
  });
  return (
    <>
      {/* <div id="global-loader">
                <div className="whirly-loader"> </div>
            </div> */}
      <div className="main-wrapper">
        <div className="header">
          <div className="header-left active">
            <div className="logo logo-normal">
              <img
                src={
                  getCompanyInfo?.LogoImagePath
                    ? "/assets/img/" + getCompanyInfo.LogoImagePath
                    : "/assets/img/logo.png"
                }
                alt="Company Logo"
              />
            </div>
            <a href="index.html" className="logo logo-white">
              <img src="/assets/img/logo-white.png" alt="" />
            </a>
            <div href="index.html" className="logo-small">
              <img
                  src={
                    getCompanyInfo?.LogoSmallImagePath
                      ? "/assets/img/" + getCompanyInfo.LogoSmallImagePath
                      : "/assets/img/logo-small.png"
                  }
                  alt="Company Logo"
              />
            </div>
            <a id="toggle_btn" href="/;">
              <Icons.ChevronLeft className="feather-16" />
            </a>
          </div>

          <a id="mobile_btn" className="mobile_btn" href="#sidebar">
            <span className="bar-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </a>

          <ul className="nav user-menu">
            <li className="nav-item nav-searchinputs"></li>

            {/* <li className="nav-item nav-item-box">
              <a href="/;" id="btnFullscreen">
                <Icons.Maximize />
              </a>
            </li> */}



            <li className="nav-item dropdown nav-item-box">
              <a
                href="/;"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                <Icons.Bell />
                <span className="badge rounded-pill">{getNotifications !== undefined ? getNotifications.length : "0"}</span>
              </a>
              <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header">
                  <span className="notification-title">Notifications</span>
                  <div onClick={ () => clearAllNotifications() } className="clear-noti">
                    Clear All
                  </div>
                </div>
                <div className="noti-content">
                  <ul className="notification-list">
                    {renderNoti}
                  </ul>
                </div>
                <div className="topnav-dropdown-footer">
                  <p>Notifications</p> 
                 {/* <Link to="/">View all Notifications</Link> */}
                </div> 
              </div>
            </li>




            <li className="nav-item dropdown has-arrow main-drop">
              <a
                href="/"
                className="dropdown-toggle nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info">
                  <span className="user-letter">
                    <img
                      src="/assets/img/profiles/noimage.jpg"
                      alt=""
                      className="img-fluid"
                    />
                  </span>
                  <span className="user-detail">
                    <span className="user-name">{getFullName}</span>
                    <span className="user-role">{getRoleName}</span>
                  </span>
                </span>
              </a>
              <div className="dropdown-menu menu-drop-user">
                <div className="profilename">
                  <div className="profileset">
                    <span className="user-img">
                      <img src="/assets/img/profiles/noimage.jpg" alt="" />
                      <span className="status online"></span>
                    </span>
                    <div className="profilesets">
                      <h6>{getFullName}</h6>
                      <h5>{getRoleName}</h5>
                    </div>
                  </div>
                  <hr className="m-0" />
                  <Link to="user-profile" className="dropdown-item">
                   {" "}
                   <Icons.User className="me-2" /> My Profile
                  </Link>
                   <Link to="reset-password" className="dropdown-item">
                   {" "}
                   <Icons.User className="me-2" /> Reset Password
                  </Link>
                  <Link to="calendar" className="dropdown-item">
                   {" "}
                   <Icons.Calendar className="me-2" /> My Calendar
                  </Link>
                  
                  <Link
                    className="dropdown-item logout pb-0"
                    onClick={handleLogout}
                    to="/login"
                  >
                    <img
                      src="/assets/img/icons/log-out.svg"
                      className="me-2"
                      alt="img"
                    />
                    Logout
                  </Link>
                </div>
              </div>
            </li>
          </ul>

          <div className="dropdown mobile-user-menu">
            <a
              href="/;"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {/* <Link className="dropdown-item" to="/home/user-profile">
                My Profile
              </Link> */}
              <Link className="dropdown-item" to="/home/reset-password">
                Reset Password
              </Link>
              {/* <a className="dropdown-item" href="general-settings.html">
                Settings
              </a> */}
              <Link className="dropdown-item" onClick={handleLogout} to="/login">
                Logout
              </Link>
            </div>
          </div>
        </div>

        <div className="sidebar" id="sidebar">
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li className="submenu-open">
                  <h6 className="submenu-hdr">Menu</h6>
                  <ul>
                    <SideBarMenu
                      menuData={getUserModules !== undefined ? getUserModules : []}
                      onMenuClick={closeSidebar}
                    />
                    {/* <li className="submenu">
                                            <Link to="/"><Icons.Tool /><span>Administration</span><span
                                                className="menu-arrow"></span>
                                            </Link>
                                            <ul>
                                                <li><NavLink  to="/home/addUser">Users</NavLink></li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <Link to=""><Icons.Grid /><span>Dashboard</span><span
                                                className="menu-arrow"></span>
                                            </Link>
                                            <ul>
                                                <li><NavLink  to="/home/dashboard">Admin Dashboard</NavLink></li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <Link to="/"><Icons.Smartphone /><span>Application</span>
                                                <span className="menu-arrow"></span>
                                            </Link>
                                            <ul>
                                                <li><NavLink  to="/home/toDo">To Do..</NavLink></li>
                                            </ul>
                                        </li> */}
                  </ul>
                </li>
                {/* <li className="submenu-open">
                  <h6 className="submenu-hdr">Favorites<span className="FavoritesStar"><FontAwesomeIcon icon={faStar} /></span></h6>
                  <ul>
                    <li>
                      <Link to="/home/mgmt-report">
                        <Icons.Paperclip />
                        <span>Management Report</span>
                      </Link>
                    </li>
                  </ul>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="page-wrapper">
          <div className="content">
            <Outlet />
          </div>
        </div>
      </div>
      {/* <Helmet>
            <script src="/assets/js/script.js" type="text/javascript" crossorigin></script>
        </Helmet> */}
      <SKAlerts alert={alert} />
    </>
  );
};

export default Home;
